import React, {useImperativeHandle, useRef, useCallback, useState, useEffect} from 'react';
import overlaySVG from '../../../images/svg/region-caches/zec-bsl.svg';
import {validateNum, ValideCoordinateCache} from "./valideCoordinateCache";
import {Map, AdvancedMarker, useMap, useMapsLibrary} from "@vis.gl/react-google-maps";

const geo = require('./mapgeo.json')

const containerStyle = {
    width: '100%', height: '100vh',
};

const libraries = ['places'];
const label = {text: `Nouvelle cache`, color: '#FFEF00'};

const MapComponent = React.forwardRef((props, ref) => {
    const [markers, setMarkers] = useState([]);
    const map = useMap()

    useImperativeHandle(ref, (value) => ({
        validateMarker(value) {
            handlevalidateMarker(value);
        },
        coordinateChanged(lat, lng) {
            setMarkers([{lat: lat, lng: lng}])
        }
    }));

    const {coordinatesZEC} = props

    function handlevalidateMarker(verifier) {

        let latitude = Number(document.getElementById('Latitude').value);
        let longitude = Number(document.getElementById('Longitude').value);

        if (map) {
            setMarkers(prevMarkers => {
                return [{lat: Number(latitude), lng: Number(longitude)}]
            });
        }

        if (verifier === 1) {

            const [coordinateOk, message] = ValideCoordinateCache(latitude, longitude);
            if (coordinateOk) {
                alert('PARFAIT');
            } else {
                //alert(message);
                console.log(message);
                alert(message);
            }
        }

    }

    useEffect(() => {
        if (!map) return;

        const bounds = new window.google.maps.LatLngBounds(new window.google.maps.LatLng(coordinatesZEC.minLat, coordinatesZEC.minLng), new window.google.maps.LatLng(coordinatesZEC.maxLat, coordinatesZEC.maxLng));

        map.fitBounds(bounds);
        const features = map.data.addGeoJson(geo)

        map.data.setStyle({fillColor: "#3DFF00", fillOpacity: 0.3, strokeColor: "#3DFF00", strokeWeight: 1, clickable: false})

        return () => {
            features.forEach(f => map.data.remove(f))
        }
    }, [map, coordinatesZEC])

    const onMapClick = (event) => {
        //Add marker
        setMarkers([{lat: event.detail.latLng.lat, lng: event.detail.latLng.lng}]);

        props.newClickSurLaCarte(event.detail.latLng.lat.toFixed(4), event.detail.latLng.lng.toFixed(4));
    };

    if (coordinatesZEC.center.lat === 0) return <></>

    return (<Map
            style={ containerStyle }
            zoomControl={ true }
            defaultCenter={ coordinatesZEC.center }
            defaultZoom={ 13 }
            mapId={ "DEMO_MAP_ID" }
            mapTypeId={ 'hybrid' }
            onClick={ onMapClick }
            onMapTypeIdChanged={ (e) => console.log(e) }
        >
            { markers.map((marker, index) => {
                return (<AdvancedMarker key={ index } position={ marker } title={ 'Nouvelle cache' }/>

                );
            }) }

        </Map>

    )
})

export default MapComponent;
